// 所属服务 serviceTool 业务工具,publicTool 公共工具
const service = "serviceTool";
// 前台路由
const web_routers = [
  {
    path: "oneTablePlatform",
    name: "oneTablePlatform",
    component: {
      render: (e) => e("router-view"),
    },
    redirect: { name: "myDataCenter" },
    meta: {
      title: "个人数据中心",
    },
    children: [
      {
        path: "myDataCenter",
        name: "myDataCenter",
        component: () =>
          import(
            /* webpackChunkName: "[request]" */ "../view/forestage/myDataCenter/Index.vue"
          ),
        meta: {
          title: "个人数据中心",
          icon: "icon-shujuguanli",
          showFoot: false,
        },
      },
      {
        path: "errorCorrectionPage",
        name: "errorCorrectionPage",
        component: () =>
          import(
            /* webpackChunkName: "[request]" */ "../view/forestage/errorCorrectionPage/Index.vue"
          ),
        meta: {
          title: "纠错页面",
        },
      },
      {
        path: "errorCorrectionRecord",
        name: "errorCorrectionRecord",
        component: () =>
          import(
            /* webpackChunkName: "[request]" */ "../view/forestage/errorCorrectionRecord/Index.vue"
          ),
        meta: {
          title: "纠错记录",
        },
      },
    ],
  },
];
// 后台路由
const cms_routers = {
  path: "oneTablePlatform",
  name: "cmsoneTablePlatform",
  component: () =>
    import(
      /* webpackChunkName: "[request]" */ "../layouts/backstage/OneTableLayout.vue"
    ),
  redirect: { name: "pageManagement" },
  meta: {
    title: "一张表",
  },
  children: [
    {
      path: "pageManagement",
      name: "pageManagement",
      component: () =>
        import(
          /* webpackChunkName: "[request]" */ "../view/backstage/pageManagement/Index.vue"
        ),
      meta: {
        title: "页面管理",
        icon: "icon-wendang",
      },
    },
    {
      path: "pageManagementCreate",
      name: "pageManagementCreate",
      component: () =>
        import(
          /* webpackChunkName: "[request]" */ "../view/backstage/pageManagementCreate/Index.vue"
        ),
      meta: {
        title: "页面创建",
        icon: "",
        head: false,
        layout: false,
      },
    },
    {
      path: "errorCorrectionSummary",
      name: "errorCorrectionSummary",
      component: () =>
        import(
          /* webpackChunkName: "[request]" */ "../view/backstage/errorCorrectionSummary/Index.vue"
        ),
      meta: {
        title: "纠错汇总",
        icon: "icon-shuju1",
      },
    },
    {
      path: "pageManagementDetail",
      name: "pageManagementDetail",
      component: () =>
        import(
          /* webpackChunkName: "[request]" */ "../view/backstage/pageManagementDetail/Index.vue"
        ),
      meta: {
        title: "页面管理预览",
        icon: "",
        headNav: false,
        layout: false,
      },
    },
  ],
};
export default {
  service,
  web: web_routers,
  cms: cms_routers,
};
